import React from "react";
import { useParams } from "react-router-dom";
import LogInComponent from "../../components/LogInComponent/LogInComponent";

const LogIn = ({ admin = false }) => {
  const { LogInId } = useParams();
  console.log("LogIn id", LogInId);

  return (
    <div className="login-container">
          <img src="/cb_logo.png" alt="ClientBloom Logo" className="layout-login-logo" />
          <LogInComponent admin={admin} />
    </div>
  );
};

export default LogIn;